import React from 'react';
import RacesClubSection from './RacesClubSection';

const ClubCorredoresSection = () => {
  const corredores = [
    {
      name: "Miguel Ángel Gutiérrez",
      participations: "+150",
      specialty: "Distancia: 50-100k en terrenos con desnivel.",
      achievements: [
        "Turdetania 55k",
        "Ronda 101",
        "Mantener el entreno a pesar de una lesión vertebral lumbar"
      ],
      image: "/assets/images/corredores/miguel.jpg",
      races: [
        { year: 2023, race: "Turdetania 55k", position: "Finalista" },
        { year: 2024, race: "Ronda 101", position: "Finalista" }
      ]
    },
    {
      name: "Irene Sánchez",
      participations: "70",
      specialty: "Distancia: 7-10k en asfalto.",
      achievements: [
        "Conseguir bajar 75 kilos",
        "20 podios en la temporada 2022",
        "47 podios en la temporada 2023"
      ],
      image: "/assets/images/corredores/irene.jpeg",
      races: [
        { year: 2024, race: "Carrera Reyes Magos Peñaflor", position: "3ª Senior femenina" },
        { year: 2024, race: "Carrera Nocturna San Antonio Abad", position: "2ª Senior femenina y top 10 general" },
        { year: 2024, race: "Media Maratón Puente Genil", position: "3ª Senior femenina" }
      ]
    },
    {
      name: "Ana Jurado",
      participations: "20",
      specialty: "Distancia: 7-10k en asfalto.",
      achievements: ["3 podios en la temporada 2023"],
      image: "/assets/images/corredores/anajurado.jpg",
      races: [
        { year: 2023, race: "Carrera Popular Esquivel", position: "2ª Veterana A" },
        { year: 2023, race: "Cross Popular Espartinas", position: "2ª Senior femenina" }
      ]
    },
    {
      name: "Manuel Lago García",
      participations: "20",
      specialty: "Distancia: 7-10k en asfalto.",
      achievements: ["1 podio en la temporada 2023"],
      image: "/assets/images/corredores/manuellago.jpeg",
      races: [
        { year: 2023, race: "Cross Popular Espartinas", position: "2º Senior masculino" }
      ]
    },
    {
      name: "Inmaculada López",
      participations: "25",
      specialty: "Distancia: 7-10k en asfalto.",
      achievements: [
        "Conseguir bajar 20 kilos",
        "11 podios en la temporada 2023"
      ],
      image: "/assets/images/corredores/inma.jpg",
      races: [
        { year: 2024, race: "Carrera Reyes Magos Peñaflor", position: "2ª Veterana A" },
        { year: 2024, race: "Carrera Nocturna San Antonio Abad", position: "2ª Veterana A" },
        { year: 2024, race: "Carrera Urbana Chiclana", position: "2ª Senior femenina" }
      ]
    },
    {
      name: "Rubén Arias",
      participations: "25",
      specialty: "Distancia: 7-10k en asfalto.",
      achievements: [
        "Conseguir bajar 27 kilos",
        "2 podios en la temporada 2023"
      ],
      image: "/assets/images/corredores/rubenarias.jpg",
      races: [
        { year: 2024, race: "Carrera Popular Tamarguillo", position: "1º Senior masculino" }
      ]
    }
  ];

  return (
    <section className="club-corredores-section">
      <div className="container">
        <div className="section-header text-center">
          <h2>Club de Corredores</h2>
          <p>
            El Club de Corredores de Equipo MAG nació en 2022 como resultado de la pasión por la carrera de nuestros compañeros.
            Fomentamos el running y creamos una comunidad de apoyo entre corredores de todos los niveles.
          </p>
        </div>
        <div className="row">
          {corredores.map((runner, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="card h-100 border-0 shadow-sm">
                <img src={runner.image} className="card-img-top" alt={runner.name} />
                <div className="card-body bg-light">
                  <h5 className="card-title text-secondary">{runner.name}</h5>
                  <p className="card-text">
                    <strong>Participaciones:</strong> {runner.participations}<br />
                    <strong>Especialidad:</strong> {runner.specialty}
                  </p>
                  <ul className="list-unstyled">
                    {runner.achievements.map((ach, idx) => (
                      <li key={idx} className="text-muted">• {ach}</li>
                    ))}
                  </ul>
                  {runner.races && (
                    <div className="mt-3">
                      <h6 className="text-success">Participaciones en Carreras</h6>
                      <table className="table table-borderless table-sm">
                        <thead>
                          <tr className="text-secondary">
                            <th>Año</th>
                            <th>Carrera</th>
                            <th>Posición</th>
                          </tr>
                        </thead>
                        <tbody>
                          {runner.races.map((race, idx) => (
                            <tr key={idx}>
                              <td>{race.year}</td>
                              <td>{race.race}</td>
                              <td>{race.position}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="section-footer text-center mt-5">
          <RacesClubSection/>
        </div>
      </div>
    </section>
  );
};

export default ClubCorredoresSection;
